module.exports = "<bs-navbar></bs-navbar>\n\n<main role=\"main\" class=\"container\">\n  <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main